<template>
  <div class="regions-list-component">
    <InnerTitle>
      <template v-slot:title>
        Мы доставляем
      </template>
    </InnerTitle>
    <div class="row regions-list">
      <div class="col-md-6 regions-list-col">
        <div class="regions-list-title">
          В районы:
        </div>
        <div class="row">
          <div
            v-for="col in districtsCols"
            class="col-md-6"
          >
            <div
              v-for="(region, key) in col"
              :key="`district-${key}`"
              class="region-link-row"
            >
              <nuxt-link :to="`/delivery/${region.slug}`">
                {{ region.name }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 regions-list-col">
        <div class="regions-list-title">
          В населенные пункты:
        </div>
        <div class="row">
          <div
            v-for="col in citiesCols"
            class="col-md-4"
          >
            <div
              v-for="(region, key) in col"
              :key="`city-${key}`"
              class="region-link-row"
            >
              <nuxt-link :to="`/delivery/${region.slug}`">
                {{ region.name }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import InnerTitle from '~/components/UI/InnerTitle'

export default {
  components: {
    InnerTitle,
  },
  computed: {
    ...mapGetters({
      districts: 'regions/getDistricts',
      cities: 'regions/getCities',
    }),
    districtsCols () {
      const chunkSize = _.ceil(this.districts.length / 2)
      return _.chunk(this.districts, chunkSize)
    },
    citiesCols () {
      const chunkSize = _.ceil(this.cities.length / 3)
      return _.chunk(this.cities, chunkSize)
    },
  },
}
</script>

<style lang="less" scoped>
  .regions-list-component {
    margin-bottom: 40px;

    .regions-list {
      padding-top: 30px;

      .regions-list-title {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 500;
      }

      .regions-list-col {
        .region-link-row {
          margin-bottom: 10px;
          a {
            font-family: 'Roboto', Arial, sans-serif;
            font-weight: 300;
            font-size: 14px;
            color: #000;
            text-decoration: none;
            //padding-bottom: 1px;
            border-bottom: 1px dashed #000;
            transition: all ease 0.3s;

            &:hover {
              text-decoration: none;
              border-bottom-color: transparent;
            }
          }
        }
      }

    }
  }
</style>
